import React from 'react';
import { filter, cloneDeep, concat, size, remove } from "lodash";
import { Box, Button, Chip, Icons, Typography } from '@curves/ui-base';

import { filterTargetTypeMap } from "@Local/Dashboard/staticData";
import { useChartContext } from "@Local/Dashboard/Components/ChartContext";

const RuleTaggedSelectBox = (props) => {
    const {
        sourceData
    } = props;
    const {
        getDialog,
        selectedFilter,
        setSelectedFilter,
        setSourceData,
    } = useChartContext();
    const memberTags = filter(selectedFilter, (item) =>
        item.targetType === filterTargetTypeMap.memberTag
        || item.targetType === filterTargetTypeMap.memberDynamicTag
        || item.targetType === filterTargetTypeMap.memberMeasureTag
        || item.targetType === filterTargetTypeMap.memberWorkoutTag
    );
    const memberOrderTags = filter(selectedFilter, (item) =>
        item.targetType === filterTargetTypeMap.memberPurchaseTag
        || item.targetType === filterTargetTypeMap.memberOrderTag
    );
    const doRefresh = () => {
    };
    const doConfirmTagged = (selected) => {
        let nextSelected = cloneDeep(selectedFilter);
        remove(nextSelected, item => {
            return item.targetType === filterTargetTypeMap.memberTag
                || item.targetType === filterTargetTypeMap.memberDynamicTag
                || item.targetType === filterTargetTypeMap.memberOrderTag
                || item.targetType === filterTargetTypeMap.memberMeasureTag
                || item.targetType === filterTargetTypeMap.memberPurchaseTag
                || item.targetType === filterTargetTypeMap.memberWorkoutTag;
        });
        setSelectedFilter(concat(nextSelected, selected));
        setSourceData(null);
    };
    const handleSelectRules = () => {
        const dialog = getDialog();
        const { memberTagGroupOptions, orderTagGroupOptions } = sourceData;
        dialog.openAdvancedChartFilterTaggedDialog(
            { memberTagGroupOptions, orderTagGroupOptions },
            doRefresh, selectedFilter, doConfirmTagged)
    };
    return (
        <Box onClick={handleSelectRules}>
            {size(memberTags) > 0 && (
                <Box className="tag-selector-box">
                    <Typography>會員標籤</Typography>
                    {memberTags && memberTags.map((tag) => {
                        return <Chip key={tag.targetID} label={tag.targetName} color={'primary'} />;
                    })}
                    <Box className={'text-right cursor-pointer'}>
                        <Icons.Edit color={"primary"} fontSize={'small'} />
                    </Box>
                </Box>
            )}
            {size(memberOrderTags) > 0 && (
                <Box className="tag-selector-box">
                    <Typography>購買項目標籤</Typography>
                    {memberOrderTags && memberOrderTags.map((tag) => {
                        return <Chip key={tag.targetID} label={tag.targetName} color={'primary'} />;
                    })}
                    <Box className={'text-right cursor-pointer'}>
                        <Icons.Edit color={"primary"} fontSize={'small'} />
                    </Box>
                </Box>
            )}
            {size(memberTags) === 0 && size(memberOrderTags) === 0 && (
                <Button color="primary"><Icons.Plus color={"primary"} /> 選擇搜尋項目</Button>
            )}
        </Box>
    );
};
export default RuleTaggedSelectBox;